import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import CommonBtn from '../../components/global/CommonBtn'
import { formatCardNumber, formatMobile } from '../../components/global/FormatString'
import { encryptionHandler, isUserLoggedIn, isTimeBeforeCurrentFacilityTime } from '../../utils/helper'
import { EMPTY_OBJECT, EVENT_TYPES, errorMessages } from '../../constants/globalConstants'
import { dynamicPaymentGateByNonce, getSessionDetails } from '../../redux/actions/booking'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { Circles } from 'react-loader-spinner'
import URL from '../../constants/urls'
import { globalKeyStore } from '../../redux/actions/globalState'
import { getConfigDetails } from '../../services/config'
import CONSTANTS from '../../redux/constants'

function ConfirmationPage({ prevFormStep, dispatch, isLoader, userDetails, selectedFacilityId, selectedCard, notify }) {
    const navigate = useNavigate()
    const { facility, event_id } = useParams()

    const { pathname } = useLocation()
    const partnername = pathname?.split('/')?.filter(v => v != '')

    const [localIsBookingClosed, setLocalIsBookingClosed] = useState(false)

    const bookingData = JSON.parse(localStorage.getItem('bookingFormDetail')) ? JSON.parse(localStorage.getItem('bookingFormDetail')) : '{}'
    // const userDataLoc = JSON.parse(localStorage.getItem('userData'))
    const { personal_info, payment_detail, get_event_type, event_data, sessionDetails, user_consent, payment_profile_id } = (bookingData) ? bookingData : EMPTY_OBJECT
    const { name, email, phone } = (personal_info) ? personal_info : EMPTY_OBJECT
    const { card_pan, card_date_expiry_month, card_date_expiry_year, card_card_security_cvx_2 } = (payment_detail) ? payment_detail : EMPTY_OBJECT
    const phone_number = formatMobile(phone)
    const card = card_pan ? formatCardNumber(card_pan) : selectedCard?.card_last_four ? formatCardNumber('000000000000' + selectedCard?.card_last_four) : ''

    useEffect(() => {
        const updatedDetails = {
            ...bookingData,
            personal_info: { name: (userDetails?.name) ? userDetails?.name : name, email: (userDetails?.email) ? userDetails?.email : email, phone: (userDetails?.phone_number) ? userDetails?.phone_number : phone },
        }
        localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
    }, [isUserLoggedIn()])


    useEffect(() => {
        if (!personal_info) {
            // navigate(`/${partnername?.[0]}`)
            if (facility) {
                navigate(`/${partnername?.[0]}/${facility}`)
            } else {
                navigate(`/${partnername?.[0]}`)
            }
            navigate(0)
        }
    }, [])

    const onClickSubmit = () => {
        const eventTypeLoc = localStorage.getItem('selectEventType')
        const encryptedPayload = {
            name_on_card: (name) ? name : '',
            card_number: (card_pan) ? card_pan : '',
            expiration_date: `${(card_date_expiry_month) ? card_date_expiry_month : ''}/${(card_date_expiry_year) ? card_date_expiry_year : ''}`,
            security_code: (card_card_security_cvx_2) ? card_card_security_cvx_2 : '',
            zip_code: ''
        }

        let encryptCardData = ''
        if (encryptedPayload?.expiration_date == '' && encryptedPayload?.card_number == '') {
            encryptCardData = ''
        } else if ((encryptedPayload?.expiration_date && encryptedPayload?.card_number)) {
            encryptCardData = encryptionHandler(encryptedPayload)
        }

        const selLocalFacilityId = facility ? facility : JSON.parse(localStorage?.getItem('selectedFacilityId'))

        if (selLocalFacilityId || selectedFacilityId) {
            const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
            dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

            //EOS-622-user-is-able-to-book-an-event-at-old-price
            // Call Session API to Verify if the Event Price is Correct and Updated and will not mismatch
            const sessionPayload = {
                'is_first_load': 1,
                'facility_id': eventFacilityid,
                'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                'event_id': get_event_type == EVENT_TYPES?.EVENT ? event_data?.id : '',
                'client_id': getConfigDetails()?.CLIENT_SECRET,
                'message': 'Reverification of Event Rate',
            }
            if(sessionDetails?.coupon_code && sessionDetails?.coupon_code != ''){
                sessionPayload.promocode = sessionDetails?.coupon_code 
                sessionPayload.name = name
                sessionPayload.phone = phone
                sessionPayload.email = email
                sessionPayload.promo = email
            }
            dispatch(getSessionDetails(sessionPayload)).then((res) => {
                dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                if(Number(res?.data?.amount) == Number(sessionDetails?.data?.amount)){
                    let finalPayload = {}
                    let facilityTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
                    let isBookingClosedCheck = isTimeBeforeCurrentFacilityTime(event_data?.stop_event_booking_time, facilityTimeZone)
                    if (get_event_type !== EVENT_TYPES?.EVENT && eventTypeLoc == 'pass') {
                        const passEventIds = event_data?.all_event?.map((item) => item?.id)
                        finalPayload = {
                            'facility_id': eventFacilityid,
                            'name': name,
                            'phone': phone,
                            'email': email,
                            'total': sessionDetails?.data?.amount,
                            'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                            'event_id': '',
                            'event_category_id': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.event_category_event?.event_category_id : event_data?.event_category_id,
                            'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event[0]?.start_time,
                            'event_type': get_event_type,
                            'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                            'reference': sessionDetails?.data?.reference,
                            'ex_month': card_date_expiry_month,
                            'ex_year': card_date_expiry_year,
                            'user_consent': (user_consent) ? user_consent : '0',
                            'nonce': encryptCardData,
                            'event_ids': passEventIds,
                            'is_booking_direct': (payment_detail) ? '0' : '1',
                            'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                            'user_id': (isUserLoggedIn()) ? userDetails?.id : '',
                            'payment_profile_id': (payment_profile_id) ? payment_profile_id : ''
                        }
                    } else {
                        finalPayload = {
                            'facility_id': eventFacilityid,
                            'name': name,
                            'phone': phone,
                            'email': email,
                            'total': sessionDetails?.data?.amount,
                            'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                            'event_id': get_event_type == EVENT_TYPES?.EVENT ? event_data?.id : '',
                            'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event[0]?.start_time,
                            'event_type': get_event_type,
                            'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                            'user_consent': (user_consent) ? user_consent : '0',
                            'nonce': encryptCardData,
                            'payment_profile_id': (payment_profile_id) ? payment_profile_id : '',
                            'is_booking_direct': (payment_detail) ? '0' : '1',
                            'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                            'user_id': (isUserLoggedIn()) ? userDetails?.id : ''
                        }
                    }
                    if (sessionDetails?.data?.discounted_amount > 0) {
                        finalPayload.discount_amount = sessionDetails?.data?.discounted_amount
                    }

                    if (isUserLoggedIn()) {
                        finalPayload.card_last_four = selectedCard?.card_last_four ? selectedCard?.card_last_four : ''
                        finalPayload.expiry = selectedCard?.expiry ? selectedCard?.expiry : ''
                    }

                    if (isBookingClosedCheck) {
                        setLocalIsBookingClosed(isBookingClosedCheck)
                        notify('error', errorMessages?.soldOutError)
                    } else {
                        dispatch(dynamicPaymentGateByNonce(finalPayload)).then((res) => {
                            if (res?.data) {
                                if (facility && !event_id) {
                                    navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_SUCCESS1}`)
                                } else {
                                    navigate(`/${partnername?.[0]}/${URL?.PAYMENT_SUCCESS1}`)
                                }
                                localStorage.setItem('paymentResponse', JSON.stringify(res?.data))
                            } else {
                                if (facility) {
                                    navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_FAIL2}`)
                                } else {
                                    navigate(`/${partnername?.[0]}/${URL?.PAYMENT_FAIL2}`)
                                }

                                localStorage.setItem('paymentResponse', JSON.stringify(res))
                            }
                        })
                    }
                }else{
                    notify('error', 'The event price has been updated. Kindly reselect the event from the start and proceed with the booking again.')
                    setTimeout(() => {
                        if (facility) {
                            navigate(`/${partnername?.[0]}/${facility}`)
                        } else {
                            navigate(`/${partnername?.[0]}`)
                        }
                    }, 3000)
                }
                
            }).catch((err) => {
                dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessages?.somethingWentWrong)
            })
            //EOS-622-user-is-able-to-book-an-event-at-old-price
        }
    }


    return (
        <div className="card">
            <div className="card-body">
                <div className="row">
                    <div className="col">
                        <div className="d-flex mb-3 align-items-center ">
                            <label ><b>Personal  Information</b></label>
                            <CommonBtn onClick={prevFormStep} isIconBtn className="btn btn-sm ms-3 p-0" icon={<i className="fa fa-pencil" aria-hidden="true"></i>} />
                        </div>
                        <p><b>{name}</b><br /> {email}<br /> {phone_number} </p>
                    </div>
                    {((payment_detail?.card_date_expiry_month && payment_detail?.card_date_expiry_year) || selectedCard) && <div className="col">
                        <div className="d-flex mb-3  align-items-center ">
                            <label ><b>Payment Details</b></label>
                            <CommonBtn onClick={prevFormStep} isIconBtn className="btn btn-sm ms-3 p-0" icon={<i className="fa fa-pencil" aria-hidden="true"></i>} />
                        </div>
                        <p><i className="fa fa-credit-card" aria-hidden="true"></i> {card} <span className="ms-4"><i className="fa fa-calendar" aria-hidden="true"></i>   {(card_date_expiry_month && card_date_expiry_year) ? card_date_expiry_month + '/' + card_date_expiry_year : selectedCard.expiry}</span> </p>
                    </div>}
                </div>
                <Button variant="primary" type='button' className="btn btn-primary btn" onClick={onClickSubmit} disabled={(isLoader || localIsBookingClosed) ? true : false}>
                    <div className='d-flex justify-content-center align-items-center' disabled={(isLoader) ? true : false}>
                        <span>{localIsBookingClosed ? 'Sold Out' : 'Confirm & Pay'} </span>  <span>
                            {isLoader ? <Circles
                                height="20"
                                width="20"
                                style={{ display: 'inline-block' }}
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                visible={true}
                            /> : null}
                        </span>
                    </div>
                </Button>
                <CommonBtn className="btn btn-secondary ms-1" onClick={prevFormStep} value='Cancel' />
            </div>
        </div>
    )
}

ConfirmationPage.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    nextFormStep: PropTypes.func,
    bookingFormDetail: PropTypes.object,
    prevFormStep: PropTypes.number,
    isLoader: PropTypes.bool,
    userDetails: PropTypes.object,
    selectedFacilityId: PropTypes.string,
    selectedCard: PropTypes.string,
}

ConfirmationPage.defaulProps = {
    dispatch: noop,
    notify: noop,
    nextFormStep: noop,
    bookingFormDetail: EMPTY_OBJECT,
    prevFormStep: 0,
    isLoader: false,
    userDetails: EMPTY_OBJECT,
    selectedFacilityId: '',
    selectedCard: '',
}


function mapStateToProps({ globalReducers, bookingReducer, loginReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        selectedEventId: globalReducers?.selectedEventId,
        bookingFormPage: globalReducers?.bookingFormPage,
        bookingFormDetail: globalReducers?.bookingFormDetail,
        isLoader: bookingReducer?.loader,
        userDetails: (Object.keys(globalReducers?.userDetails).length > 0) ? globalReducers?.userDetails : loginReducer?.data?.data?.user,
        selectedFacilityId: globalReducers?.selectedFacilityId,
        selectedCard: globalReducers?.selectedCard,
    }
}

export default connect(mapStateToProps)(ConfirmationPage)